import getAccountProperties from './getAccountProperties'

export default function getAccountId() {
  const { id } = getAccountProperties()

  return id
}
